<script>
    import Card from './Card.svelte';
    import PurchasePaddle from './PurchasePaddle.svelte';
    import PurchasePaddleGift from './PurchasePaddleGift.svelte';
    import H2 from './H2.svelte';
    import ProductIcon from './ProductIcon.svelte';
    import { format_age_range } from './utils/format_ages';

    /** @type {Bundle} */
    export let bundle;

    /** @type {Course|undefined} */
    export let course = undefined;

    /** @type {Worksheet|undefined} */
    export let worksheet = undefined;

    export let h_level = 2;

    /** @type {string | undefined} */
    export let title = undefined;
    /** @type {string | undefined} */
    export let lead = undefined;

    let className = '';
    export { className as class };

    const items_purchased = bundle.items.filter((i) => i.purchased).length;

    const items_total = bundle.items.length;

    export let feature = 'bundle';
</script>

<Card
    class="{className} flex flex-col relative"
    href={`/bundles/${bundle.slug}`}
    aria_label={bundle.title}
>
    <H2 tag={`h${h_level}`} class="link link-el pointer-events-none">
        {#if course}
            Buy {course.title} in {bundle.title}
        {:else if worksheet}
            Buy {worksheet.title} in {bundle.title}
        {:else}
            {title || bundle.title}
        {/if}
    </H2>

    {#if bundle.min_age || bundle.max_age}
        <span
            class="text-sm mb-1 bg-surface-highlight rounded-bl-xl px-2 py-1 -ml-1 w-fit absolute top-0 right-0 text-nowrap"
        >
            {format_age_range(bundle.min_age, bundle.max_age)}
        </span>
    {/if}

    <div class="flex-1">
        {#if lead}
            <div class="my-2">{@html lead}</div>
        {:else if bundle.lead}
            <p class="my-2">{@html bundle.lead}</p>
        {/if}

        {#if bundle.purchased}
            <p class="my-2">Collection complete!</p>
        {:else if items_purchased}
            <p class="my-2">
                {items_purchased} of {items_total} items are already in your library.
            </p>
        {/if}

        <p class="my-2">
            <em class="accent">Includes {items_total} items:</em>
            {bundle.items.map((c) => c.title).join(', ')}.
        </p>
    </div>

    <div
        class="flex flex-nowrap justify-around xl:justify-start bg-black/40 w-[calc(100%+2rem)] md:w-[calc(100%+3rem)] -ml-4 md:-ml-6 px-4 py-4 my-5"
    >
        {#each bundle.items as item, index}
            <ProductIcon
                product={item}
                class="-ml-16 first:ml-0 xl:-ml-2 xl:first:ml-0 pointer-events-none"
                style="z-index: {items_total - index};"
            />
        {/each}
    </div>

    <div
        class="flex flex-col md:flex-row justify-between md:items-center gap-4 relative"
    >
        <div>
            {#if !bundle.purchased}
                <PurchasePaddle
                    product={bundle}
                    cta="Buy Bundle"
                    cta_free="Unlock for free"
                    style="small"
                    {feature}
                >
                    <svelte:fragment slot="after" let:total_discount_percent>
                        {#if total_discount_percent > 0}
                            <span
                                class="text-lg xs:text-2xl font-bold bg-purple-700 rounded-full py-1 px-2 absolute -top-16 right-0 z-20"
                                >&minus;{total_discount_percent}%</span
                            >
                        {/if}
                    </svelte:fragment>
                </PurchasePaddle>
            {/if}
        </div>
        <PurchasePaddleGift
            product={bundle}
            style="small"
            {feature}
        />
    </div>
</Card>
